// extracted by mini-css-extract-plugin
module.exports = {"camp-A":"A_camp-A__NdFH7"};